import { AlpineComponent } from '@alpinejs/csp';

const Marquee = (): AlpineComponent => ({
  paused: false,
  init() {
    const parent = this.$root;
    const clone = parent.innerHTML;

    // Copy content a few times
    parent.insertAdjacentHTML('beforeend', clone);
    parent.insertAdjacentHTML('beforeend', clone);

    const translate = (parent.scrollWidth - window.innerWidth) * -1;
    parent.style = `--max-translate: ${translate}px;`;
  },
  handleMouseEnter() {
    this.paused = true;
  },
  handleMouseLeave() {
    this.paused = false;
  },
  getClassName() {
    return this.paused ? 'marquee--paused' : '';
  }
});

export default Marquee;
